/**
 * @generated SignedSource<<efa8e2e6ac61f55bd1ddb045d25cafc2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UpdatePollSettingsQuery$variables = {
  id: string;
};
export type UpdatePollSettingsQuery$data = {
  readonly webForm: {
    readonly settings?: {
      readonly allowSubmissionDeletion: boolean | null;
      readonly endDate: string | null;
      readonly membersSeeAllResults: boolean | null;
    };
  } | null;
};
export type UpdatePollSettingsQuery = {
  response: UpdatePollSettingsQuery$data;
  variables: UpdatePollSettingsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "WebFormSettings",
      "kind": "LinkedField",
      "name": "settings",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "membersSeeAllResults",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "endDate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allowSubmissionDeletion",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "WebForm",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdatePollSettingsQuery",
    "selections": [
      {
        "alias": "webForm",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UpdatePollSettingsQuery",
    "selections": [
      {
        "alias": "webForm",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "81258686274795152de6825f07a3c64e",
    "id": null,
    "metadata": {},
    "name": "UpdatePollSettingsQuery",
    "operationKind": "query",
    "text": "query UpdatePollSettingsQuery(\n  $id: ID!\n) {\n  webForm: node(id: $id) {\n    __typename\n    ... on WebForm {\n      settings {\n        membersSeeAllResults\n        endDate\n        allowSubmissionDeletion\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "b7b9247a88d86b514014801aa1e3e8b9";

export default node;
